export default "__VITE_ASSET__7b5fad51__"